__webpack_require__.p = "/areas/beliefnet/app/dist/";